module.exports = __webpack_public_path__ + "img/news16_2.5852c376.jpg";